import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';
import notificacionService from 'qreventos-suite/notificaciones';

class SuiteConfig {
  evento: number = 805;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
  clientId: string = '8bd8020a-ad7d-489f-aaed-9846f74d06a7-805';

  TEMPLATE_MAIL_RECUPERAR_ACREDITADO: number = 3162;
  
  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;

    invitacionService.clientId = this.clientId;
    invitacionService.token = this.token;

    notificacionService.clientId = this.clientId;
    notificacionService.token = this.token;
  }
}

export default new SuiteConfig();
